module.exports = __webpack_public_path__ + "static/media/bg_2.e3d387ad.png";